module.exports = __webpack_public_path__ + "img/variable_decl_with_initialization.31e0cb43.png";